import { createReducer } from '@reduxjs/toolkit'
import { DictT, TourT } from 'types/model'
import { clear, logout, receiveTours } from 'model/actions'

const initialState = {} as DictT<TourT>

const reducer = createReducer(initialState, builder => {
  builder
    .addCase(receiveTours, (state, action) => action.payload)
    .addCase(clear, () => initialState)
    .addCase(logout, () => initialState)
})

export default reducer
